<app-heading [isbreadcrumb]="false" [title]="'Assign Talent pools for the Candidate'" [showToggle]="false" [button]="false"></app-heading>

<div class="sm:mb-4">
    <p-button (click)="goToCreateNewTalentPool()" [label]="'Create New Talent Pool'" [rounded]="true"
        icon="pi pi-plus" size="large" />
</div>

<div class="projects-data">
    <div class="grid grid-nogutter">
        <div class="col-12 p-0 mb-3">
            <div class="grid grid-nogutter">
                <div class="col-12 md:col-6 xl:col-6 lg:col-6 sm:col-12 p-0">
                    <div class="wrap-left">
                       <div class="grid grid-nogutter">
                            <div class="md:pr-1 sm:pr-0 col-12 md:col-4 sm:col-12 ">
                                <p-iconField iconPosition="right">
                                    <p-inputIcon (click)="onSearchClick()"  styleClass="pi pi-search" />
                                    <input [(ngModel)]="searchText" (keydown)="onEnter($event)" type="text" pInputText placeholder="Search" />
                                </p-iconField>
                            </div>
                        </div>
                        <div>
                            @if(showSearchChip){
                                <ul><p-chip [label]="searchTextChip" (onRemove)="onRemoveChip()" [removable]="true" /></ul>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 p-0">
            <div class="data-table">
                <p-table styleClass="p-datatable-sm p-datatable-sm--normal" [value]="talentPoolsData" dataKey="_id"
                    [tableStyle]="{ 'min-width': '60rem' }" [expandedRowKeys]="expandedRows"
                    (onRowExpand)="onRowExpand($event)" (onRowCollapse)="onRowCollapse($event)" [lazy]="true"
                    [rows]="10" [paginator]="true" [totalRecords]="totalTalentPoolCount"
                    (onLazyLoad)="getTalentPools($event)" [showCurrentPageReport]="true" [paginator]="true"
                    currentPageReportTemplate="Showing {first} - {last} of {totalRecords}" autoLayout="true" [scrollable]="true">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>
                                Name

                            </th>
                            <th>
                                {{'No of Users' | sentenceCase}}

                            </th>
                            @if (helperService.checkResponsive()) {
                                <th alignFrozen="right" pFrozenColumn>
                                  <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
                                </th>
                                } @else {
                                <th>
                                  <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
                                </th>
                            }
                            <ng-template #frozenHeader>
                            Actions
                            </ng-template>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" class="border-0" let-talentPoolsData let-expanded="expanded">
                        <tr>
                            <td><b>{{ talentPoolsData.name }}</b>
                            </td>
                            <td> {{ talentPoolsData.reviewers || talentPoolsData.reviewersCount }}</td>
                            @if (helperService.checkResponsive()) {
                                <td alignFrozen="right" pFrozenColumn>
                                  <ng-container *ngTemplateOutlet="frozenData"></ng-container>
                                </td>
                              } @else {
                                <td>
                                  <ng-container *ngTemplateOutlet="frozenData"></ng-container>
                                </td>
                              } 
                             <ng-template #frozenData>
                                <div class="wrap-actions flex align-items-center gap-2">                
                                    <span [pTooltip]="talentPoolsData.isReviewerAssigned ? 'Already a member' : 'Assign to talent pool'"
                                    tooltipPosition="top">
                                        <p-button (click)="assignTalentPoolToUser(talentPoolsData)" [rounded]="true" [text]="true"
                                        icon="true" [disabled]="talentPoolsData.isReviewerAssigned">
                                        <span class="{{helperService.getEnvironmentName()}}-icon icon-add-outlined"></span>
                                        </p-button>
                                    </span>
                                </div>
                            </ng-template>
                        </tr>
                    </ng-template>
                  
            </p-table>
        </div>
    </div>
    <div class="flex justify-content-start">
        <p-button (onClick)="backToProfile()" label="back" size="large" [rounded]="true" />
    </div>
</div>

</div>